<template>
  <a-row>
    <!-- 搜索区域 -->
    <a-row style="margin-bottom: 16px;">
      <a-col span="4">
        <a-input
          v-model="queryForm.phoneNum"
          placeholder="手机号"
          allowClear
        />
      </a-col>
      <a-col span="4" style="padding-left: 8px;">
        <a-input
          v-model="queryForm.name"
          placeholder="姓名"
          allowClear
        />
      </a-col>
      <a-col span="4" style="padding-left: 8px;">
        <a-input
          v-model="queryForm.idNumber"
          placeholder="身份证号"
          allowClear
        />
      </a-col>
      <a-col span="4" style="padding-left: 8px;">
        <a-input
          v-model="queryForm.code"
          placeholder="工号"
          allowClear
        />
      </a-col>
      <a-col span="4" style="padding-left: 8px;">
        <a-select
          v-model="queryForm.type"
          placeholder="账号类型"
          allowClear
          style="width: 100%"
        >
          <a-select-option :value="0">学生</a-select-option>
          <a-select-option :value="1" disabled>老师</a-select-option>
        </a-select>
      </a-col>
      <a-col span="4" style="padding-left: 8px; text-align: right;">
        <a-button type="primary" @click="handleSearch" :loading="loading">
          <a-icon type="search" /> 搜索
        </a-button>
        <a-button style="margin-left: 8px;" @click="handleReset">
          <a-icon type="reload" /> 重置
        </a-button>
      </a-col>
    </a-row>
    <a-row style="margin-bottom: 16px;">
      <a-col span="4">
        <a-select
          v-model="queryForm.frozen"
          placeholder="冻结状态"
          allowClear
          style="width: 100%"
        >
          <a-select-option :value="true">已冻结</a-select-option>
          <a-select-option :value="false">未冻结</a-select-option>
        </a-select>
      </a-col>
    </a-row>

    <!-- 数据表格 -->
    <a-table
      :columns="columns"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      row-key="id"
      @change="handleTableChange"
    >
      <div slot="nameIdNumber" slot-scope="text, record">
        <div class="account-meta-col">
          <div class="account-meta-line">
            <span class="account-meta-k">姓名</span>
            <span class="account-meta-v account-ellipsis" :title="record.name != null ? String(record.name) : ''">{{
              record.name != null && String(record.name).trim() ? record.name : '—'
            }}</span>
          </div>
          <div class="account-meta-line">
            <span class="account-meta-k">身份证号</span>
            <span class="account-meta-v account-ellipsis" :title="record.idNumber != null ? String(record.idNumber) : ''">{{
              record.idNumber != null && String(record.idNumber).trim() ? record.idNumber : '—'
            }}</span>
          </div>
        </div>
      </div>

      <div slot="typeFrozen" slot-scope="text, record">
        <div class="account-meta-col">
          <div class="account-meta-line account-meta-line--tags">
            <!-- <span class="account-meta-k">账号类型</span> -->
            <div class="account-meta-v account-meta-tags">
              <a-tag v-if="record.type === 0" color="blue">学生</a-tag>
              <a-tag v-else-if="record.type === 1" color="green">老师</a-tag>
              <a-tag v-else color="default">未知</a-tag>
            </div>
          </div>
          <div class="account-meta-line account-meta-line--tags">
            <!-- <span class="account-meta-k">冻结</span> -->
            <div class="account-meta-v account-meta-tags">
              <a-tag v-if="record.frozen === true" color="red">已冻结</a-tag>
              <a-tag v-else-if="record.frozen === false" color="green">未冻结</a-tag>
              <span v-else>—</span>
            </div>
          </div>
        </div>
      </div>

      <div slot="roleListCol" slot-scope="text, record">
        <div v-if="record.roleList && record.roleList.length" class="account-meta-tags">
          <a-tag v-for="role in record.roleList" :key="role.id != null ? role.id : role.name" style="margin-bottom: 4px">
            {{ role.name || '—' }}
          </a-tag>
        </div>
        <span v-else style="color: #999;">—</span>
      </div>
      
      <div slot="gmtBlock" slot-scope="text, record">
        <div class="account-meta-col">
          <div class="account-meta-line account-meta-line--time">
            <span class="account-meta-k">创建时间</span>
            <span class="account-meta-v">{{ $moment(record.gmtCreate).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </div>
          <div class="account-meta-line account-meta-line--time">
            <span class="account-meta-k">修改时间</span>
            <span class="account-meta-v">{{
              record.gmtModified ? $moment(record.gmtModified).format('YYYY-MM-DD HH:mm:ss') : '—'
            }}</span>
          </div>
        </div>
      </div>
      
      <!-- 兑换教材册数列 -->
      <span slot="redeemTextBookCount" slot-scope="text, record">
        <CommonPermissions :p="$permissions.ACCOUNT_MGT.RETRIEVE">
          <a
            @click="() => viewRedeemTextbooks(record)"
            style="color: #1890ff; cursor: pointer;"
          >
            {{ record.redeemTextBookCount || 0 }}
          </a>
        </CommonPermissions>
      </span>
      
      <!-- 学籍信息列 -->
      <div slot="studentInfo" slot-scope="text, record">
        <div v-if="record.type === 0 && record.jwStudentList && record.jwStudentList.length > 0">
          <div 
            v-for="(student, index) in record.jwStudentList" 
            :key="student.id"
            style="margin-bottom: 8px; padding: 8px; border: 1px solid #f0f0f0; border-radius: 4px; background-color: #fafafa;"
          >
            <div style="font-size: 12px; color: #666; margin-bottom: 4px;">
              学籍信息 {{ index + 1 }}
            </div>
            <div style="display: flex; flex-wrap: wrap; gap: 8px; font-size: 12px;">
              <span><strong>学号：</strong>{{ student.code || '-' }}</span>
              <span><strong>院系：</strong>{{ student.jwDeptName || '-' }}</span>
              <span><strong>专业：</strong>{{ student.jwMajorName || '-' }}</span>
              <span><strong>班级：</strong>{{ student.jwClazzName || '-' }}</span>
              <span><strong>状态：</strong>
                {{ student.schoolRollLabel || '-' }}
              </span>
            </div>
          </div>
        </div>
        <div v-else-if="record.type === 0" style="color: #999; font-size: 12px;">
          暂无学籍信息
        </div>
        <div v-else style="color: #999; font-size: 12px;">
          非学生账号
        </div>
      </div>
      
      <!-- 操作列 -->
      <span slot="action" slot-scope="text, record">
        <CommonPermissions :p="$permissions.ACCOUNT_MGT.RETRIEVE">
          <a @click="() => viewAccount(record)">查看</a>
        </CommonPermissions>
        <CommonPermissions :p="$permissions.ACCOUNT_MGT.UPDATE">
          <a-divider type="vertical" />
          <a @click="() => openRoleModal(record)">角色</a>
        </CommonPermissions>
        <template v-if="record.type === 0">
          <CommonPermissions :p="$permissions.ACCOUNT_MGT.UPDATE">
            <a-divider type="vertical" />
            <a @click="() => openFreezeRecordDrawer(record)">冻结记录</a>
          </CommonPermissions>
          <CommonPermissions :p="$permissions.ACCOUNT_MGT.UPDATE">
            <a-divider type="vertical" />
            <a v-if="record.frozen !== true" @click="() => openFreezeModal(record)">冻结</a>
            <span v-else class="op-muted">冻结</span>
          </CommonPermissions>
          <CommonPermissions :p="$permissions.ACCOUNT_MGT.UPDATE">
            <a-divider type="vertical" />
            <a-popconfirm
              v-if="record.frozen === true"
              title="确定解除该账号的冻结？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="() => unfreezeRow(record)"
            >
              <a>解除冻结</a>
            </a-popconfirm>
            <span v-else class="op-muted">解除冻结</span>
          </CommonPermissions>
        </template>
      </span>
    </a-table>

    <!-- 账号详情抽屉 -->
    <a-drawer
      title="账号详情"
      placement="right"
      width="50%"
      :closable="false"
      :visible="showDetailDrawer"
      @close="() => triggerDetailDrawer()"
    >
      <div v-if="currentAccount">
        <a-descriptions :column="1" bordered>
          <a-descriptions-item label="账号ID">{{ currentAccount.id }}</a-descriptions-item>
          <a-descriptions-item label="姓名">{{ currentAccount.name || '-' }}</a-descriptions-item>
          <a-descriptions-item label="手机号">{{ currentAccount.phoneNum || '-' }}</a-descriptions-item>
          <a-descriptions-item label="身份证号">{{ currentAccount.idNumber || '-' }}</a-descriptions-item>
          <a-descriptions-item label="工号">{{ currentAccount.code || '-' }}</a-descriptions-item>
          <a-descriptions-item label="账号类型">
            <a-tag v-if="currentAccount.type === 0" color="blue">学生</a-tag>
            <a-tag v-else-if="currentAccount.type === 1" color="green">老师</a-tag>
            <a-tag v-else color="default">未知</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="冻结状态">
            <a-tag v-if="currentAccount.frozen === true" color="red">已冻结</a-tag>
            <a-tag v-else-if="currentAccount.frozen === false" color="green">未冻结</a-tag>
            <span v-else>—</span>
          </a-descriptions-item>
          <a-descriptions-item label="角色">
            <template v-if="currentAccount.roleList && currentAccount.roleList.length">
              <a-tag v-for="role in currentAccount.roleList" :key="role.id != null ? role.id : role.name" style="margin-bottom: 4px">
                {{ role.name || '—' }}
              </a-tag>
            </template>
            <span v-else>—</span>
          </a-descriptions-item>
          <a-descriptions-item label="兑换教材册数">{{ currentAccount.redeemTextBookCount || 0 }}</a-descriptions-item>
          <a-descriptions-item label="创建时间">
            {{ $moment(currentAccount.gmtCreate).format('YYYY-MM-DD HH:mm:ss') }}
          </a-descriptions-item>
          <a-descriptions-item label="修改时间">
            {{ currentAccount.gmtModified ? $moment(currentAccount.gmtModified).format('YYYY-MM-DD HH:mm:ss') : '-' }}
          </a-descriptions-item>
        </a-descriptions>
        
        <div style="margin-top: 24px; text-align: right;">
          <a-button @click="() => triggerDetailDrawer()">关闭</a-button>
        </div>
      </div>
    </a-drawer>

    <!-- 冻结记录抽屉（学生账号） -->
    <a-drawer
      title="冻结记录"
      placement="right"
      width="65%"
      :closable="true"
      :visible="showFreezeRecordDrawer"
      :destroyOnClose="true"
      @close="closeFreezeRecordDrawer"
    >
      <div v-if="freezeRecordAccount" style="margin-bottom: 12px; color: rgba(0,0,0,0.65);">
        <span><strong>姓名：</strong>{{ freezeRecordAccount.name || '—' }}</span>
        <span style="margin-left: 16px;"><strong>手机号：</strong>{{ freezeRecordAccount.phoneNum || '—' }}</span>
        <span style="margin-left: 16px;"><strong>身份证号：</strong>{{ freezeRecordAccount.idNumber || '—' }}</span>
      </div>
      <a-table
        :columns="freezeRecordColumns"
        :data-source="freezeRecordList"
        :loading="freezeRecordLoading"
        row-key="id"
        :pagination="false"
        size="small"
        :scroll="{ x: 900 }"
      >
        <span slot="fFreezeUntil" slot-scope="text">
          {{ text ? $moment(text).format('YYYY-MM-DD HH:mm:ss') : '—' }}
        </span>
        <span slot="fEnable" slot-scope="text">
          <a-tag v-if="text === 1" color="green">生效</a-tag>
          <a-tag v-else color="red">已失效</a-tag>
        </span>
        <span slot="fGmtCreate" slot-scope="text">
          {{ text ? $moment(text).format('YYYY-MM-DD HH:mm:ss') : '—' }}
        </span>
        <span slot="fGmtModified" slot-scope="text">
          {{ text ? $moment(text).format('YYYY-MM-DD HH:mm:ss') : '—' }}
        </span>
      </a-table>
    </a-drawer>

    <a-modal
      title="设置账号冻结"
      :visible="showFreezeModal"
      :confirmLoading="freezeSubmitting"
      ok-text="确定"
      cancel-text="取消"
      :destroyOnClose="true"
      @ok="submitFreeze"
      @cancel="closeFreezeModal"
    >
      <a-form-model ref="freezeFormRef" :model="freezeForm" :rules="freezeFormRules" layout="vertical">
        <a-form-model-item label="冻结截止时间" prop="freezeUntil">
          <a-date-picker
            v-model="freezeForm.freezeUntil"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            style="width: 100%"
            placeholder="请选择冻结截止时间"
          />
        </a-form-model-item>
        <a-form-model-item label="冻结原因" prop="reason">
          <a-textarea
            v-model="freezeForm.reason"
            :rows="3"
            :maxLength="500"
            placeholder="选填，最多 500 字"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal
      title="设置角色"
      :visible="showRoleModal"
      :confirmLoading="roleSubmitting"
      ok-text="确定"
      cancel-text="取消"
      :destroyOnClose="true"
      @ok="submitRoleModal"
      @cancel="closeRoleModal"
    >
      <a-spin :spinning="roleModalLoading">
        <div v-if="roleModalAccount" style="margin-bottom: 12px; color: rgba(0,0,0,0.65);">
          <span><strong>姓名：</strong>{{ roleModalAccount.name || '—' }}</span>
          <span style="margin-left: 16px;"><strong>手机号：</strong>{{ roleModalAccount.phoneNum || '—' }}</span>
        </div>
        <div>
          <div style="margin-bottom: 8px;">角色（可多选）</div>
          <a-select
            v-model="roleSelectedIds"
            mode="multiple"
            placeholder="请选择角色"
            style="width: 100%"
            option-filter-prop="children"
            allow-clear
          >
            <a-select-option v-for="opt in roleOptionList" :key="opt.id" :value="opt.id">
              {{ opt.name || opt.id }}
            </a-select-option>
          </a-select>
        </div>
      </a-spin>
    </a-modal>

    <!-- 兑换教材弹窗 -->
    <a-modal
      title="兑换教材列表"
      :visible="showRedeemModal"
      :width="800"
      :footer="null"
      @cancel="() => triggerRedeemModal()"
    >
      <div v-if="currentAccount">
        <div style="margin-bottom: 16px;">
          <strong>学生：</strong>{{ currentAccount.name || '-' }} 
          <span style="margin-left: 16px;">
            <strong>手机号：</strong>{{ currentAccount.phoneNum || '-' }}
          </span>
        </div>
        
        <a-table
          :columns="redeemColumns"
          :data-source="redeemData"
          :pagination="redeemPagination"
          :loading="redeemLoading"
          row-key="id"
          size="small"
          @change="handleRedeemTableChange"
        >
          <!-- 教材封面列 -->
          <div slot="thumbUrl" slot-scope="text, record">
            <img 
              v-if="record.textbook && record.textbook.thumbUrl" 
              :src="record.textbook.thumbUrl" 
              style="width: 40px; height: 50px; object-fit: cover; border-radius: 4px;"
              @error="handleImageError"
            />
            <div v-else style="width: 40px; height: 50px; background-color: #f5f5f5; border-radius: 4px; display: flex; align-items: center; justify-content: center; color: #999; font-size: 12px;">
              无封面
            </div>
          </div>
          
          <!-- 教材信息列 -->
          <div slot="textbookInfo" slot-scope="text, record">
            <div v-if="record.textbook">
              <div style="font-weight: bold; margin-bottom: 4px;">{{ record.textbook.title || '-' }}</div>
              <div style="font-size: 12px; color: #666; margin-bottom: 2px;">
                <strong>作者：</strong>{{ record.textbook.authors || '-' }}
              </div>
              <div style="font-size: 12px; color: #666; margin-bottom: 2px;">
                <strong>出版社：</strong>{{ record.textbook.publishers || '-' }}
              </div>
              <div style="font-size: 12px; color: #666;">
                <strong>ISBN：</strong>{{ record.textbook.isbn || '-' }}
              </div>
            </div>
            <div v-else style="color: #999;">-</div>
          </div>
          
          <!-- 兑换时间列 -->
          <span slot="redeemTime" slot-scope="text, record">
            {{ $moment(record.redeemTime).format('YYYY-MM-DD HH:mm:ss') }}
          </span>
          
          <!-- 发放班级列 -->
          <span slot="jwClazz" slot-scope="text, record">
            {{ record.jwClazz ? record.jwClazz.name : '-' }}
          </span>
        </a-table>
      </div>
    </a-modal>
  </a-row>
</template>

<script>
import { mapState } from 'vuex'
import AccountMgtApi from '@/api/src/account_mgt/api/AccountMgtApi'
import RoleApi from '@/api/src/role/api/RoleApi'
import CommonPermissions from '@/components/CommonPermissions'

const accountMgtApi = new AccountMgtApi()
const roleApi = new RoleApi()

// 兑换教材表格列定义
const redeemColumns = [
  {
    title: '封面',
    dataIndex: 'thumbUrl',
    key: 'thumbUrl',
    width: 60,
    scopedSlots: { customRender: 'thumbUrl' },
  },
  {
    title: '教材信息',
    key: 'textbookInfo',
    scopedSlots: { customRender: 'textbookInfo' },
  },
  {
    title: '兑换时间',
    dataIndex: 'redeemTime',
    key: 'redeemTime',
    width: 150,
    scopedSlots: { customRender: 'redeemTime' },
  },
  {
    title: '发放班级',
    dataIndex: 'jwClazz',
    key: 'jwClazz',
    width: 120,
    scopedSlots: { customRender: 'jwClazz' },
  },
]

const freezeRecordColumns = [
  {
    title: '冻结截止时间',
    dataIndex: 'freezeUntil',
    key: 'freezeUntil',
    width: 180,
    scopedSlots: { customRender: 'fFreezeUntil' },
  },
  { title: '冻结原因', dataIndex: 'reason', key: 'reason', ellipsis: true },
  {
    title: '状态',
    dataIndex: 'enable',
    key: 'enable',
    width: 100,
    scopedSlots: { customRender: 'fEnable' },
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    key: 'gmtCreate',
    width: 170,
    scopedSlots: { customRender: 'fGmtCreate' },
  },
  {
    title: '更新时间',
    dataIndex: 'gmtModified',
    key: 'gmtModified',
    width: 170,
    scopedSlots: { customRender: 'fGmtModified' },
  },
]

const columns = [
  {
    title: '姓名 / 身份证号',
    key: 'nameIdNumber',
    width: 260,
    scopedSlots: { customRender: 'nameIdNumber' },
  },
  {
    title: '手机号',
    dataIndex: 'phoneNum',
    key: 'phoneNum',
  },
  {
    title: '工号',
    dataIndex: 'code',
    key: 'code',
  },
  {
    title: '账号类型 / 冻结',
    key: 'typeFrozen',
    scopedSlots: { customRender: 'typeFrozen' },
  },
  {
    title: '角色',
    key: 'roleListCol',
    scopedSlots: { customRender: 'roleListCol' },
  },
  {
    title: '学籍信息',
    key: 'studentInfo',
    scopedSlots: { customRender: 'studentInfo' },
    width: 300,
  },
  {
    title: '创建时间 / 修改时间',
    key: 'gmtBlock',
    width: 260,
    scopedSlots: { customRender: 'gmtBlock' },
  },
  {
    title: '兑换教材册数',
    dataIndex: 'redeemTextBookCount',
    key: 'redeemTextBookCount',
    scopedSlots: { customRender: 'redeemTextBookCount' },
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'Account',
  components: {
    CommonPermissions,
  },
  data() {
    return {
      columns: columns,
      data: [],
      loading: false,
      showDetailDrawer: false,
      currentAccount: null,
      showRedeemModal: false,
      redeemData: [],
      redeemLoading: false,
      redeemColumns: redeemColumns,
      redeemPagination: {
        current: 1,
        total: 0,
        pageSize: 10
      },
      queryForm: {
        phoneNum: '',
        name: '',
        idNumber: '',
        code: '',
        type: 0,
        frozen: undefined
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10
      },
      showFreezeRecordDrawer: false,
      freezeRecordLoading: false,
      freezeRecordList: [],
      freezeRecordAccount: null,
      freezeRecordColumns: freezeRecordColumns,
      showFreezeModal: false,
      freezeSubmitting: false,
      freezeOpRecord: null,
      freezeForm: {
        freezeUntil: null,
        reason: '',
      },
      freezeFormRules: {
        freezeUntil: [{ required: true, message: '请选择冻结截止时间', trigger: 'change' }],
      },
      showRoleModal: false,
      roleModalAccount: null,
      roleOptionList: [],
      roleSelectedIds: [],
      roleInitialIds: [],
      roleModalLoading: false,
      roleSubmitting: false,
    }
  },
  computed: {
    ...mapState('security', {
      securityUser: (state) => state.user || {},
    }),
  },
  async mounted() {
    await this.fetchAccounts(1)
  },
  methods: {
    // 获取账号列表
    async fetchAccounts(pageNum) {
      this.loading = true
      try {
        const queryForm = {
          pageNum: pageNum,
          pageSize: this.pagination.pageSize,
          phoneNum: this.queryForm.phoneNum || undefined,
          name: this.queryForm.name || undefined,
          idNumber: this.queryForm.idNumber || undefined,
          code: this.queryForm.code || undefined,
          type: this.queryForm.type
        }
        if (this.queryForm.frozen === true || this.queryForm.frozen === false) {
          queryForm.frozen = this.queryForm.frozen
        }

        const resp = await accountMgtApi.findPageAccount(queryForm)
        console.log(resp)
        
        this.data = resp.list || []
        this.pagination.current = resp.pageNum || 1
        this.pagination.total = resp.total || 0
        this.pagination.pageSize = resp.pageSize || 10
      } catch (error) {
        console.error('获取账号列表失败:', error)
        this.$message.error('获取账号列表失败')
      } finally {
        this.loading = false
      }
    },
    
    // 搜索
    async handleSearch() {
      this.pagination.current = 1
      await this.fetchAccounts(1)
    },
    
    // 重置
    handleReset() {
      this.queryForm = {
        phoneNum: '',
        name: '',
        idNumber: '',
        code: '',
        type: undefined,
        frozen: undefined
      }
      this.pagination.current = 1
      this.fetchAccounts(1)
    },
    
    // 表格变化
    async handleTableChange(pagination) {
      console.log('表格变化:', pagination)
      await this.fetchAccounts(pagination.current)
    },
    
    // 查看账号详情
    viewAccount(record) {
      this.currentAccount = record
      this.showDetailDrawer = true
    },
    
    // 编辑账号
    editAccount(record) {
      this.$message.info('编辑功能待开发')
      console.log('编辑账号:', record)
    },
    
    // 获取学籍状态颜色
    getStatusColor(status) {
      if (!status) return 'default'
      
      const statusLower = status.toLowerCase()
      
      // 正常状态 - 绿色
      if (statusLower.includes('正常') || statusLower.includes('在校') || statusLower.includes('在读')) {
        return 'green'
      }
      
      // 毕业状态 - 蓝色
      if (statusLower.includes('毕业') || statusLower.includes('已毕业')) {
        return 'blue'
      }
      
      // 休学状态 - 橙色
      if (statusLower.includes('休学') || statusLower.includes('暂停')) {
        return 'orange'
      }
      
      // 退学状态 - 红色
      if (statusLower.includes('退学') || statusLower.includes('开除') || statusLower.includes('取消')) {
        return 'red'
      }
      
      // 其他状态 - 默认灰色
      return 'default'
    },
    
    
    // 控制详情抽屉显示
    triggerDetailDrawer() {
      this.showDetailDrawer = !this.showDetailDrawer
      if (!this.showDetailDrawer) {
        this.currentAccount = null
      }
    },
    
    // 查看兑换教材
    async viewRedeemTextbooks(record) {
      this.currentAccount = record
      this.showRedeemModal = true
      this.redeemPagination.current = 1
      await this.fetchRedeemTextbooks(this.currentAccount.id, 1)
    },
    
    // 获取兑换教材列表
    async fetchRedeemTextbooks(accountId, pageNum) {
      this.redeemLoading = true
      try {
        const resp = await accountMgtApi.findPagingRedeemTextbookByAccountId(accountId, pageNum)
        console.log('兑换教材列表:', resp)
        
        this.redeemData = resp.list || []
        this.redeemPagination.current = resp.pageNum || 1
        this.redeemPagination.total = resp.total || 0
        this.redeemPagination.pageSize = resp.pageSize || 10
      } catch (error) {
        console.error('获取兑换教材列表失败:', error)
        this.$message.error('获取兑换教材列表失败')
      } finally {
        this.redeemLoading = false
      }
    },
    
    // 兑换教材表格变化
    async handleRedeemTableChange(pagination) {
      console.log('兑换教材表格变化:', pagination)
      await this.fetchRedeemTextbooks(pagination.current)
    },
    
    // 控制兑换教材弹窗显示
    triggerRedeemModal() {
      this.showRedeemModal = !this.showRedeemModal
      if (!this.showRedeemModal) {
        this.redeemData = []
        this.currentAccount = null
      }
    },
    
    // 图片加载错误处理
    handleImageError(event) {
      event.target.style.display = 'none'
      event.target.nextElementSibling.style.display = 'flex'
    },

    openFreezeRecordDrawer(record) {
      this.freezeRecordAccount = record
      this.showFreezeRecordDrawer = true
      this.loadFreezeRecordList(record.id)
    },
    closeFreezeRecordDrawer() {
      this.showFreezeRecordDrawer = false
      this.freezeRecordAccount = null
      this.freezeRecordList = []
    },
    async loadFreezeRecordList(accountId) {
      this.freezeRecordLoading = true
      this.freezeRecordList = []
      try {
        const list = await accountMgtApi.getAccountFreezeList(accountId)
        this.freezeRecordList = Array.isArray(list) ? list : []
      } catch (e) {
        console.error(e)
        this.$message.error((e && e.message) || '获取冻结记录失败')
      } finally {
        this.freezeRecordLoading = false
      }
    },

    openFreezeModal(record) {
      this.freezeOpRecord = record
      this.freezeForm = { freezeUntil: null, reason: '' }
      this.showFreezeModal = true
      this.$nextTick(() => {
        if (this.$refs.freezeFormRef && this.$refs.freezeFormRef.clearValidate) {
          this.$refs.freezeFormRef.clearValidate()
        }
      })
    },
    closeFreezeModal() {
      this.showFreezeModal = false
      this.freezeOpRecord = null
      this.freezeForm = { freezeUntil: null, reason: '' }
    },
    submitFreeze() {
      return new Promise((resolve, reject) => {
        this.$refs.freezeFormRef.validate((valid) => {
          if (!valid) {
            reject()
            return
          }
          this.freezeSubmitting = true
          const m = this.freezeForm.freezeUntil
          const freezeUntil = m && typeof m.toDate === 'function' ? m.toDate() : m
          const body = {
            freezeUntil,
            reason: (this.freezeForm.reason && this.freezeForm.reason.trim()) || undefined,
          }
          accountMgtApi
            .freezeAccount(this.freezeOpRecord.id, body)
            .then(() => {
              this.$message.success('已设置冻结')
              this.closeFreezeModal()
              this.fetchAccounts(this.pagination.current)
              resolve()
            })
            .catch((e) => {
              this.$message.error((e && e.message) || '操作失败')
              reject(e)
            })
            .finally(() => {
              this.freezeSubmitting = false
            })
        })
      })
    },

    async unfreezeRow(record) {
      try {
        await accountMgtApi.unfreezeAccount(record.id)
        this.$message.success('已解除冻结')
        await this.fetchAccounts(this.pagination.current)
      } catch (e) {
        console.error(e)
        this.$message.error((e && e.message) || '操作失败')
      }
    },

    roleListInitialIds(record) {
      return (record && record.roleList ? record.roleList : [])
        .map((r) => (r && r.id != null ? r.id : null))
        .filter((id) => id != null)
    },

    async openRoleModal(record) {
      this.roleModalAccount = record
      this.roleInitialIds = this.roleListInitialIds(record)
      this.roleSelectedIds = this.roleInitialIds.slice()
      this.showRoleModal = true
      this.roleModalLoading = true
      this.roleOptionList = []
      try {
        const companyId =
          this.securityUser &&
          this.securityUser.company &&
          this.securityUser.company.id != null
            ? this.securityUser.company.id
            : undefined
        const opts =
          companyId !== undefined && companyId !== null && companyId !== ''
            ? { companyId }
            : {}
        const list = await roleApi.getRoleList(opts)
        this.roleOptionList = Array.isArray(list) ? list : []
      } catch (e) {
        console.error(e)
        this.$message.error((e && e.message) || '加载角色列表失败')
        this.closeRoleModal()
      } finally {
        this.roleModalLoading = false
      }
    },

    closeRoleModal() {
      this.showRoleModal = false
      this.roleModalAccount = null
      this.roleOptionList = []
      this.roleSelectedIds = []
      this.roleInitialIds = []
    },

    submitRoleModal() {
      if (!this.roleModalAccount || this.roleModalAccount.id == null) {
        this.closeRoleModal()
        return Promise.resolve()
      }
      const accountId = this.roleModalAccount.id
      const initial = new Set(this.roleInitialIds)
      const selected = new Set(this.roleSelectedIds.filter((id) => id != null))
      const toRemove = [...initial].filter((id) => !selected.has(id))
      const toAdd = [...selected].filter((id) => !initial.has(id))
      if (toRemove.length === 0 && toAdd.length === 0) {
        this.$message.success('未变更')
        this.closeRoleModal()
        return Promise.resolve()
      }
      this.roleSubmitting = true
      const run = async () => {
        try {
          await Promise.all(toRemove.map((roleId) => accountMgtApi.removeAccountRole(accountId, roleId)))
          await Promise.all(toAdd.map((roleId) => accountMgtApi.setAccountRole(accountId, roleId)))
          this.$message.success('角色已更新')
          this.closeRoleModal()
          await this.fetchAccounts(this.pagination.current)
        } catch (e) {
          console.error(e)
          this.$message.error((e && e.message) || '保存角色失败')
          throw e
        } finally {
          this.roleSubmitting = false
        }
      }
      return run()
    },
  }
}
</script>

<style scoped lang="less">
.ant-table-wrapper {
  margin-top: 16px;
}

.account-meta-col {
  min-width: 0;
  line-height: 1.5;
}

.account-meta-line {
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;

  & + & {
    margin-top: 4px;
  }
}

.account-meta-k {
  flex: none;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}

.account-meta-v {
  flex: 1;
  min-width: 0;
}

.account-meta-line--time {
  align-items: center;

  .account-meta-v {
    font-size: 12px;
    font-variant-numeric: tabular-nums;
  }
}

.account-meta-line--tags {
  align-items: center;
}

.account-meta-tags {
  line-height: 1.5;
}

.account-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}

.op-muted {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
  user-select: none;
}
</style>